import store from '../store'

const permissions = {
  hasPermission: function(key) {
    // console.log('object.hasPermission', store.getters.permissions)
    if (!store.getters.permissions) {
      return false
    }
    return store.getters.permissions.indexOf(key) !== -1 || false
  }
}
export default permissions
